module.exports = __webpack_public_path__ + "assets/img/shouye_menpiaoyuding.d62eb4d1.svg";